import { FaCopy } from 'react-icons/fa';

export const About = (props) => {
  const copyPolicy = () => {
    navigator.clipboard.writeText('d7eefa7b3becf54624a23095457a6cd023ceff3e0a9c988bab721d71')
  }

  return (
    <div id="about">
      <div className="container">
        <div>
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="about-text">
                <h2>About the Society</h2>
                <h4>{props.data ? props.data.paragraph : "loading..."}</h4>
              </div>
            </div>
            <div className="col-xs-12 col-md-6" style={{display: 'flex', justifyContent:'center'}}>
              {" "}
              <img src="img/about2.gif" className="img-responsive" alt="" />{" "}
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="about-text">
                <h2>Join the adventure</h2>
                <h4>{props.data ? props.data.paragraph2 : "loading..."}</h4>
              </div>
            </div>
            <div className="col-xs-12 col-md-6" style={{display: 'flex', justifyContent:'center'}}>
              {" "}
              <img src="img/greybone.jpg" className="img-responsive" alt="" />{" "}
            </div>
          </div>

          <div className='text-center'>
            <p style={{ wordBreak: 'break-all', marginBottom: 15, paddingRight: 10}} >Policy Id: d7eefa7b3becf54624a23095457a6cd023ceff3e0a9c988bab721d71</p>
            <FaCopy style={{cursor: 'pointer'}} onClick={copyPolicy}/>
          </div>
        </div>
      </div>
    </div>
  );
};
